import { TJobCase } from "@/features/job/types/JobForm";

export const generateDefaultCaseName = (jobName: string, existingCases: TJobCase[] = []): string => {
  if (!jobName) return "";

  const nextNumber = existingCases.length + 1;
  return `${jobName}(${nextNumber})`;
};
